import React from 'react';
import useDashboardApexChart from '../../hook/useDashboardApexChart';

const SubscribersGraph = ({ graphData }) => {

    const { createUserChart } = useDashboardApexChart();

    const {
        totalSubscribers = 0,
        todaySubscribers = 0,
        trendSubscribers = [],
        xAxisLabels = []
    } = graphData || {};

    return (
        <div className="col-xxl-12">
            <div className="card radius-8 border-0 p-20">
                <div className="row gy-4">

                    {/* STAT CARDS */}
                    <div className="col-xxl-3 d-flex flex-column">

                        <div className="card p-3 radius-8 shadow-none bg-gradient-dark-start-1 mb-12 flex-fill">
                            <div className="card-body p-0">
                                <div className="d-flex align-items-center gap-2 mb-12">
                                    <span className="mb-0 w-48-px h-48-px bg-base text-2xl d-flex justify-content-center align-items-center rounded-circle h6"
                                        style={{ color: '#f6a623' }}>
                                        <i className="ri-vip-crown-fill"></i>
                                    </span>
                                    <span className="fw-medium text-secondary-light text-lg">
                                        Total Pro
                                    </span>
                                </div>
                                <div className="d-flex align-items-center justify-content-between">
                                    <h5 className="fw-semibold mb-0">{totalSubscribers}</h5>
                                </div>
                            </div>
                        </div>

                        <div className="card p-3 radius-8 shadow-none bg-gradient-dark-start-2 mb-12 flex-fill">
                            <div className="card-body p-0">
                                <div className="d-flex align-items-center gap-2 mb-12">
                                    <span className="mb-0 w-48-px h-48-px bg-base text-2xl d-flex justify-content-center align-items-center rounded-circle h6"
                                        style={{ color: '#f6a623' }}>
                                        <i className="ri-star-fill"></i>
                                    </span>
                                    <span className="fw-medium text-secondary-light text-lg">
                                        Today Pro
                                    </span>
                                </div>
                                <div className="d-flex align-items-center justify-content-between">
                                    <h5 className="fw-semibold mb-0">{todaySubscribers}</h5>
                                </div>
                            </div>
                        </div>

                    </div>

                    {/* CHART */}
                    <div className="col-xxl-9">
                        <div className="card-body p-0">
                            <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between">
                                <h6 className="mb-2 mt-1 fw-bold text-lg">Pro Subscribers Trend</h6>
                            </div>

                            <ul className="d-flex justify-content-center mt-3 gap-3 stats-legend">
                                <li className="d-flex align-items-center gap-2">
                                    <span className="w-12-px h-12-px rounded-circle" style={{ background: '#f6a623' }} />
                                    Today Pro<span className="legend-value">: <b>{todaySubscribers}</b></span>
                                </li>
                            </ul>

                            <div className="mt-40">
                                <div id="subscribersChart" className="apexcharts-tooltip-style-1">
                                    {createUserChart('#f6a623', trendSubscribers, xAxisLabels, 'Subscribers')}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default SubscribersGraph;
